import { Grid } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Edit from "@material-ui/icons/Edit";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { Box, Tooltip } from "@mui/material";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CustomAlert from "components/CustomAlert/CustomAlert";
import Button from "components/CustomButtons/Button.js";
import CustomDataGrid from "components/CustomDataGrid.js/CustomDataGrid";
import CustomModal from "components/CustomModal/CustomModal";
import GridContainer from "components/Grid/GridContainer.js";
import { LoginContext } from "contexts/LoginContext";
import React, { useContext, useEffect } from "react";
import GetAllPrograms from "services/ProgramServices/GetAllPrograms";
import ProgramBatchModal from "views/Forms/ProgramBatchModal";
import ProgramForm from "views/Forms/ProgramForm";
import ProgramTemplateSelector from "./ProgramsComponents/ProgramTemplateSelector";


const useStyles = makeStyles(styles);

export default function ProgramsListing(props) {
    const [columns, setColumns] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [userEditForm, setUserEditForm] = React.useState(null);
    const [licensingMessage, setLicensingMessage] = React.useState(false);
    const [programPageState, setProgramPageState] = React.useState({
        isLoading: false,
        data: [],
        total: 0,
        page: 1,
        pageSize: 10,
    });

    const { user, licensePackageObject, userPrivileges } = useContext(LoginContext);

    const fetchPrograms = async () => {
        try {
            console.log('logging')
            setProgramPageState(prev => ({ ...prev, isLoading: true }));

            const res = await GetAllPrograms.getAllPrograms();

            const programs = res?.$values ?? [];

            setProgramPageState(prev => ({
                ...prev,
                isLoading: false,
                data: programs,
                total: programs.length,
            }));
            console.log('logged')
        } catch (error) {
            console.error("Error fetching programs", error);
            setProgramPageState(prev => ({ ...prev, isLoading: false }));
        }
    };
    useEffect(() => {
        fetchPrograms();
    }, []);

    const isPrivilege = (x) => {
        if (userPrivileges?.Privileges?.Program.indexOf(x) !== -1) {
            return true;
        }
        else {
            return false;
        }
    }
    const classes = useStyles();

    const handleRowSelection = (e) => {
        setSelection(e);
    };

    const onCellEditCommit = (p) => { };

    const onCellBlur = (e, p) => { };

    const handleEdit = (p, e) => { };

    const blankProgram = {
        key: null,
        code: "",
        name: "",
        description: "",
        durationInMonths: null,
        baseFee: null,
    };
    const openProgramForm = (program) => {
        setUserEditForm(
            <CustomModal
                modal
                title="Create Program"
                setModal={hideUserEditForm}
                content={
                    <ProgramForm
                        program={program}
                        onSubmit={(data) => {
                            console.log("Create program", data);
                            hideUserEditForm();
                        }}
                        onClose={hideUserEditForm}
                    />
                }
                showOk={false}
                maxWidth="md"
                fullWidth
            />
        );
    };

    const openTemplateSelector = () => {
        setUserEditForm(
            <CustomModal
                modal
                title="Create Program"
                setModal={hideUserEditForm}
                content={
                    <Grid container justifyContent="center">
                        <Grid item xs={12}>
                            <ProgramTemplateSelector
                                onSelect={(template) => {
                                    setUserEditForm(
                                        <CustomModal
                                            modal
                                            title="Create Program"
                                            setModal={hideUserEditForm}
                                            content={
                                                <ProgramForm
                                                    program={template}
                                                    onSubmit={(data) => {
                                                        console.log("Create program", data);
                                                        hideUserEditForm();
                                                    }}
                                                    onClose={hideUserEditForm}
                                                />
                                            }
                                            showOk={false}
                                            maxWidth="md"
                                            fullWidth={true}
                                        />
                                    );
                                }}
                            />
                        </Grid>
                        <Grid item xs={10}>
                            <Box>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    onClick={() => openProgramForm(blankProgram)}
                                >
                                    + Create With Blank
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                }
                maxWidth="md"
                fullWidth={false}
                showOk={false}
            />
        );
    };

    const handleEditProgram = (row) => {
        const fullProgram = programPageState.data.find(
            (p) => p.programId === row.programId
        );

        setUserEditForm(
            <CustomModal
                key={`edit-${row.programId}`}
                modal
                title="Edit Program"
                setModal={hideUserEditForm}
                content={
                    <ProgramForm
                        key={row?.programId || "create"}
                        program={row}
                        onSubmit={(data) => {
                            console.log("submit", data);
                            hideUserEditForm();
                        }}
                        onClose={hideUserEditForm}
                    />
                }
                showOk={false}
                maxWidth="md"
                fullWidth={true}
            />
        );
    };

    const handleEditProgramBatch = (row) => {
        console.log("row is ", row)
        const fullProgram = programPageState.data.find(
            (p) => p.programId === row.programId
        );

        setUserEditForm(
            <CustomModal
                key={`editBatch-${row.programId}`}
                modal
                title="Program Batch"
                setModal={hideUserEditForm}
                content={
                    <ProgramBatchModal
                        key={"Program Batches"}
                        program={row}
                        onSubmit={(data) => {
                            console.log("submit", data);
                            hideUserEditForm();
                        }}
                        onClose={hideUserEditForm}
                    />
                }
                showOk={false}
                maxWidth="md"
                fullWidth={true}
            />
        );
    };

    console.log("users", programPageState);
    console.log("rows", rows);
    useEffect(() => {
        if (!programPageState.data?.length) {
            setRows([]);
            return;
        }

        setRows(
            programPageState.data.map(p => ({
                id: p.programId,              // REQUIRED by DataGrid
                programId: p.programId,
                code: p.code,
                name: p.name,
                description: p.description,
                durationInMonths: p.durationInMonths,
                batches: p.batches,
                baseFee: p.baseFee,
                slabs: p.slabs?.$values,
                status: p.isActive ? "Active" : "Inactive",
            }))
        );
    }, [programPageState.data]);


    React.useEffect(() => {
        let cols = [
            {
                field: "programid",
                headerName: "#",
                width: 90,
                hide: true,
            },
            {
                field: "code",
                headerName: "Code",
                editable: false,
                width: 200,
            },
            {
                field: "name",
                headerName: "Name",
                editable: false,
                width: 200,
            },
            {
                field: "durationInMonths",
                headerName: "Duration (Month)",
                editable: false,
                width: 200,
            },
            {
                field: "baseFee",
                headerName: "Program Fee",
                editable: false,
                width: 200,
            },
            {
                field: "actions",
                headerName: "Actions",
                editable: false,
                width: 310,
                filterable: false,
                sortable: false,
                renderCell: (cellValues) => {
                    const row = cellValues.row;

                    return (
                        <>
                            {isPrivilege("UpdateProgram") == true ? (
                                <Tooltip title="Edit Program">
                                    <Button
                                        size="sm"
                                        justIcon
                                        round
                                        className={classes.actionButton}
                                        style={{ backgroundColor: "#DD4B39" }}
                                        onClick={() => handleEditProgram(row)}
                                    >
                                        <Edit />
                                    </Button>
                                </Tooltip>
                            ) : null}
                            {
                                <Tooltip title="Program Batches">
                                    <Button
                                        size="sm"
                                        justIcon
                                        round
                                        className={classes.actionButton}
                                        style={{ backgroundColor: "#DD4B39" }}
                                        onClick={() => handleEditProgramBatch(row)}
                                    >
                                        <PlaylistAddIcon />
                                    </Button>
                                </Tooltip>
                            }
                            {/* {(
                                <Tooltip title="Add Payment">
                                    <Button
                                        size="sm"
                                        justIcon
                                        round
                                        className={classes.actionButton}
                                        style={{ backgroundColor: "#4CAF50" }}
                                        onClick={() => openPaymentModal(row)}
                                    >
                                        💰
                                    </Button>
                                </Tooltip>
                            )} */}
                        </>
                    );
                },
            },
        ];

        setColumns(cols);
    }, []);

    const addCouponFormModal = async () => {
        setAddCouponForm(
            <CustomModal
                modal={true}
                setModal={() => hideAddCouponFormModal()}
                content={
                    <AddCoupon
                        isEdit={false}
                        //user={UserDetails?.user ?? row}
                        afterFinish={() => hideAddCouponFormModal()}
                        refetch={handleRefetch}
                    />
                }
                cancelButtonMessage="cancel"
                okButtonMessage="Create"
                showOk={false}
                onCancelClick={() => hideAddCouponFormModal()}
                title={"Coupon Form"}
                maxWidth="lg"
                fullWidth={true}
            />,
        );
    };
    const hideAddCouponFormModal = () => {
        setAddCouponForm(null);
    };

    const hideUserEditForm = () => {
        setUserEditForm(null);
        fetchPrograms();
    };

    const getRowClassName = (row) => {
        return null;
    };

    return (
        <Card>
            <CardHeader color="rose" icon>
                <CardIcon color="rose">
                    <SupervisorAccountIcon />
                </CardIcon>
            </CardHeader>
            <CardBody>
                <GridContainer
                    style={{ marginBottom: 21 }}
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    spacing={2}
                >
                    {isPrivilege("CreateProgram") == true ? (<Button
                        color="primary"
                        onClick={openProgramForm}       //openTemplateSelector}
                        style={{ marginTop: 20, marginRight: 20, textTransform: "none" }}
                    >
                        + Add
                    </Button>
                    ) : null}
                </GridContainer>

                <div style={{ height: 650, width: "100%" }}>
                    <div style={{ display: "flex", height: "100%" }}>
                        {programPageState.isLoading ?
                            (
                                <div style={{ flexGrow: 1 }}>
                                    <CircularProgress style={{ marginInline: "45%" }} />
                                    <h6 style={{ marginInline: "45%" }}> Loading...</h6>
                                </div>
                            ) : (
                                <div style={{ flexGrow: 1 }}>
                                    {isPrivilege("ViewProgram") == true ? (<CustomDataGrid
                                        columns={columns}
                                        rows={rows}
                                        rowCount={programPageState?.total}
                                        // loading={userFetchLoading}
                                        autoPageSize={true}
                                        onEditCellPropsChange={handleEdit}
                                        onCellEditCommit={onCellEditCommit}
                                        onSelectionModelChange={handleRowSelection}
                                        getRowClassName={getRowClassName}
                                        onCellBlur={onCellBlur}
                                    />
                                    )
                                        : ""}
                                </div>
                            )}
                    </div>
                </div>
            </CardBody>

            {licensingMessage == true && (
                <CustomAlert
                    open={true}
                    severity="warning"
                    alertMessage="Please upgrade to higher package to create additional users."
                />
            )}
            {userEditForm}
        </Card>
    );
}
